import React, { Fragment, useRef, useEffect } from 'react';
import { translate } from '@Services/translation';
import Hamburger from '@Icons/hamburger.svg';
import ArrowDown2 from '@Icons/arrow-down2.svg';

export const BREAKPOINT = 1024;

const NavigationItem = ({
    links = [],
    contentLink = null,
    level,
    additionalLinks = [],
    showDropdownIndicator = false,
}) => {
    const menuRef = useRef(null);
    const wasAboveBreakpoint = useRef(window.innerWidth > BREAKPOINT);

    const hideAll = () => {
        document.querySelectorAll('.navbar__menu--show').forEach((v) => {
            if (menuRef.current != v) {
                v.classList.remove('navbar__menu--show');
            }
        });
    };

    const toggleMenu = (e) => {
        e.preventDefault();

        if (window.innerWidth > BREAKPOINT) {
            const isShow = menuRef.current.classList.contains('navbar__menu--show');
            menuRef.current
                .closest('.navbar__menu-links')
                .querySelectorAll('.navbar__menu--show')
                .forEach((v) => {
                    v.classList.remove('navbar__menu--show');
                });
            if (!isShow) {
                menuRef.current.classList.toggle('navbar__menu--show');
            }
            if (window.updateNavHeight) {
                window.updateNavHeight();
            }
        } else {
            menuRef.current.classList.toggle('navbar__menu--show');
        }
    };

    const closeMenu = (e) => {
        e.preventDefault();
        menuRef.current
            .closest('nav')
            .querySelectorAll('.navbar__menu--show')
            .forEach((v) => {
                v.classList.remove('navbar__menu--show');
            });
    };

    useEffect(() => {
        const handleClickOutside = (e) => {
            const isOutsideMenu =
                menuRef.current && !menuRef.current.contains(e.target);
            const isNotNavbarLink = !e.target.closest('.navbar__link');
            const isNotOpenMenuBtn = !e.target.closest('.btn-open__menu');
            const isLevel1Child = e.target.closest('.navbar__menu--level1');

            if (isOutsideMenu && isNotNavbarLink && isNotOpenMenuBtn) {
                if (window.innerWidth >= BREAKPOINT || !isLevel1Child) {
                    hideAll();
                }
            }
        };

        const handleResize = () => {
            const isAboveBreakpoint = window.innerWidth > BREAKPOINT;
            if (isAboveBreakpoint !== wasAboveBreakpoint.current) {
                hideAll();
                wasAboveBreakpoint.current = isAboveBreakpoint;
            }
        };

        document.addEventListener('click', handleClickOutside);
        window.addEventListener('resize', handleResize);
        return () => {
            document.removeEventListener('click', handleClickOutside);
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const additionClass =
        contentLink && contentLink.attributes
            ? contentLink.attributes.cssValue
            : '';
    const selectedClass = contentLink && contentLink.isSelected ? 'navbar__link--selected' : '';
    const hasChildrenClass = links.length > 0 ? 'has-children' : '';
    const hasNameOrChildren = (link) => link.name || (link.links || []).length > 0;

    const userMenuButton = () => {
        var name = document.querySelector('.user-project')?.innerHTML;
        var links = Array.from(document.querySelectorAll('.menu-user__nav a'));
        if (name == undefined || links.length == 0) {
            return '';
        }
        var theLinks = links.map((v) => {
            return {
                name: v.text,
                url: v.getAttribute('href'),
                class: v.getAttribute('class'),
            };
        });

        return (
            <li className="navbar__item user-icon user-menu-button" key={'login'}>
                <NavigationItem
                    contentLink={{
                        name: name,
                    }}
                    links={theLinks}
                    showDropdownIndicator={2}
                />
            </li>
        );
    };

    return (
        <Fragment>
            {!contentLink ? (
                <a
                    className="navbar__link--block navbar__icon--menu navbar__icon btn-open__menu"
                    onClick={toggleMenu}
                    rel="nofollow"
                    href="#"
                    title={translate('code.general.menu') || 'menu'}
                >
                    <Hamburger />
                </a>
            ) : (
                <Fragment>
                    {!hasChildrenClass ?
                        <a
                            className={`navbar__link ${contentLink.class != undefined ? contentLink.class : ''} ${selectedClass} ${hasChildrenClass} ${additionClass}`}
                            href={contentLink.url || '#'}
                            dangerouslySetInnerHTML={{ __html: contentLink.name }}
                        ></a>
                        :
                        <Fragment>
                            <div
                                className={`navbar__link ${contentLink.class != undefined ? contentLink.class : ''} ${selectedClass} ${hasChildrenClass} ${additionClass}`}
                                onClick={toggleMenu}
                            >
                                <div className='content-link-wrapper' dangerouslySetInnerHTML={{ __html: contentLink.name }}></div>
                                {showDropdownIndicator && <div className="dropdown-indicator"><ArrowDown2 /></div>}
                            </div>
                            <i className="navbar__icon--caret-right navbar__icon navbar__icon--open" onClick={toggleMenu}></i>
                        </Fragment>
                    }
                </Fragment>
            )}

            {links.length > 0 && (
                <>
                    {level === 1 && <div className={`navbar__menu-bg`}></div>}
                    <div className={`navbar__menu navbar__menu--level${level}`} ref={menuRef}>
                        <div className="navbar__menu-header">
                            <div className="close-menu__wrapper"
                                onClick={closeMenu}>
                                <span
                                    className="navbar__icon navbar__icon--close"
                                ></span>
                                {translate('code.general.menu')}
                            </div>
                            {contentLink && (
                                <div className='navbar__menu-header-category'>
                                    <i
                                        className="navbar__icon--caret-left navbar__icon"
                                        onClick={toggleMenu}
                                    ></i>
                                    <span
                                        className="navbar__title"
                                        onClick={toggleMenu}
                                        dangerouslySetInnerHTML={{
                                            __html: contentLink.name,
                                        }}
                                    ></span>
                                </div>
                            )}
                        </div>
                        <ul className="navbar__menu-links">
                            {level !== 1 &&
                                <li className="show-all-category__link">
                                    {contentLink?.name != null && (
                                        <a href={contentLink.url}>
                                            <span className="label-desktop">
                                                {translate('code.general.show.all')}
                                            </span>{' '}
                                            <span className="label-mobile">
                                                {translate('code.general.show.all.short')}
                                            </span>{' '}
                                            <span>{contentLink.name}</span>
                                        </a>
                                    )}
                                </li>}
                            {links.length > 0 && links.map((link, index) => hasNameOrChildren(link) && (
                                <li className="navbar__item" key={index}>
                                    <NavigationItem links={link.links} contentLink={link} level={index + 2} showDropdownIndicator={level === 1 && index == 0} />
                                </li>
                            )
                            )}
                        </ul>
                        {!contentLink && additionalLinks &&
                            <ul className="navbar__menu-links hide-for-large extra-links">
                                {userMenuButton()}
                                {additionalLinks.additionalHeaderLinks.map((link, index) => (
                                    <li className="navbar__item" key={`link${index}`}>
                                        <a className={`navbar__link ${link.text === 'Filialer' ? 'navbar__filialer' : ''}`} href={link.href}>
                                            {link.text === 'Filialer' && (
                                                <svg className="header__top-container--afiliates-svg">
                                                    <use xlinkHref="/ui/icons/spritemap.svg#icon__map-pin"></use>
                                                </svg>
                                            )}
                                            {link.text}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        }
                    </div>
                </>
            )}
        </Fragment>
    );
};

export default NavigationItem;